export interface IMeasurement {
  id?: number
  uuid?: string
  abbreviation: string
  description: string
  type: 'length' | 'area' | 'volume' | 'other'
}

export const measurementInitValues: IMeasurement = {
  //id: 0,
  abbreviation: '',
  description: '',
  type: 'other',
}
